
import { Component, OnInit } from '@angular/core';
import { WithdrawalAdminService } from '../../_core/_services/withdrawal-admin.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { AdminWithdrawalBeneficiaryDto } from '../../_core/_model/withdrawal';

@Component({
  selector: 'app-withdrawal-beneficiaries',
  standalone: false,
  templateUrl: './withdrawal-beneficiaries.html',
  styleUrl: './withdrawal-beneficiaries.css'
})
export class WithdrawalBeneficiaries implements OnInit {
  loading = false;

  items: AdminWithdrawalBeneficiaryDto[] = [];

  filterUserId :any = '';
  filterWalletId :any = '';
  filterPaymentMethod :any = '';
  filterSearch :any = '';
  filterIsActive :any = '';

  readonly paymentMethodOptions = ['bank-transfer', 'mobile-money', 'wallet', 'interac'];

  constructor(
    private withdrawalAdminService: WithdrawalAdminService,
    private notifyService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadItems();
  }

  loadItems(): void {
    this.loading = true;

    this.withdrawalAdminService.getAdminBeneficiaries(
      this.toNullableString(this.filterUserId),
      this.toNullableString(this.filterWalletId),
      this.toNullableString(this.filterPaymentMethod),
      this.toNullableBoolean(this.filterIsActive),
      this.toNullableString(this.filterSearch)
    ).subscribe({
      next: (res) => {
        this.items = res.data || [];
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.Error?.Details || err?.error?.message || 'Failed to load beneficiaries',
          'Error'
        );
        this.items = [];
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  toggleStatus(item: AdminWithdrawalBeneficiaryDto): void {
    this.withdrawalAdminService.toggleAdminBeneficiaryStatus(item.id).subscribe({
      next: () => {
        this.notifyService.showSuccess('Beneficiary status updated', 'Success');
        this.loadItems();
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.Error?.Details || err?.error?.message || 'Failed to update beneficiary',
          'Error'
        );
      }
    });
  }

  badgeClass(active: boolean): string {
    return active ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger';
  }

  previewDestination(json: string): string {
    if (!json) return '-';

    try {
      const parsed = JSON.parse(json);
      return Object.entries(parsed)
        .slice(0, 3)
        .map(([k, v]) => `${k}: ${v}`)
        .join(' | ');
    } catch {
      return json;
    }
  }
  
  private toNullableString(value: any): string | undefined {
    const v = String(value ?? '').trim();
    return v ? v : undefined;
  }

  private toNullableBoolean(value: string): boolean | undefined {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  }
}